import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '.';

const type = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
}>();

export const createAppAsyncThunk: typeof type = createAsyncThunk;
